import "bootstrap/dist/css/bootstrap.min.css"

// FontAwesome
import { config } from "@fortawesome/fontawesome-svg-core"
import "@fortawesome/fontawesome-svg-core/styles.css"

// Fonts

// Rubik
import "@fontsource/rubik/300.css"
import "@fontsource/rubik/400.css"
import "@fontsource/rubik/600.css"
import "@fontsource/rubik/700.css"

// Roboto
import "@fontsource/roboto/100.css"
import "@fontsource/roboto/200.css"
import "@fontsource/roboto/300.css"
import "@fontsource/roboto/400.css"
import "@fontsource/roboto/600.css"
import "@fontsource/roboto/700.css"

// Asap
import "@fontsource/asap/100.css"
import "@fontsource/asap/200.css"
import "@fontsource/asap/300.css"
import "@fontsource/asap/400.css"
import "@fontsource/asap/600.css"
import "@fontsource/asap/700.css"

// Configure FontAwesome
config.autoAddCss = false
